import React, {useState, useEffect} from "react";
import {useLocation} from "react-router-dom";

import Header from "../landing-page/Header";
import Footer from "../landing-page/Footer";
import {useForm} from "react-hook-form";
import flag from "../../assets/imgs/gh.svg";
import helper, {getErrorMessage, phoneNumberRegexPattern} from "../../helpers/general_helper";
import models from "../../network/models/quick_models";
import {getUserName, getUserPhoneNumber} from "../../helpers/authenticator";
import customer from "../../network/services/customer";
import toastifyHelper from "../../helpers/toastify_helper";


const Request = () => {


  const {register, handleSubmit, watch, errors} = useForm();
  //States: SENDER; RECEIVER
  const [formState, setFormState] = useState('SENDER');
  let location = useLocation();

  let deliveryQuote = {...models.deliveryQuoteResponse, ...location.state.quote.data};
  console.log(deliveryQuote);

  useEffect(() => {
  });

  const changeFormState = (state) => {
    setFormState(state);
  }


  return (
    <>
      <Header/>
      <main className="mt-5">
        <section style={{minHeight: 650}}>
          <div className="row justify-content-center">
            <div className="col-md-4 col-lg-3 col-sm-5" style={{paddingLeft: 27, paddingRight: 27}}>
              <h3 className={'mb-3'}>{getFormTitle(formState)}</h3>
              {
                formState.toLowerCase() === 'sender' ? <RequestSenderForm/> : <RequestReceiverForm/>
              }
              <div className="d-flex justify-content-between">
                <button onClick={() => {
                  changeFormState("SENDER")
                }} className="btn btn-secondary mt-4">Previous
                </button>
                <button onClick={() => {
                  changeFormState("RECEIVER")
                }} className="btn btn-primary mt-4">Next
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer/>
    </>
  );
};

const getFormTitle = (state) => {
  return state.toUpperCase();
}

const RequestSenderForm = () => {
  const {register, handleSubmit, watch, errors} = useForm();

  return (
    <form /*onSubmit={handleSubmit(createRequest)}*/>
      <div className="text-left">
        <ul className="list-unstyled">
          <li><small>Phone number</small></li>
          <li style={{marginTop: 5}}>
            <div className="input-group">
              <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                     <img style={{height: 14, marginRight: 5}} src={flag}
                          className="img-fluid"/> +233
                  </span>
              </div>
              <input type="text" className="form-control form-control-lg input-form"
                     placeholder="Enter your phone number"
                     name="phone"
                     maxLength="10"
                     ref={register({
                       required: true,
                       min: 9,
                       max: 10,
                       pattern: phoneNumberRegexPattern()
                     })}
                     aria-label="Username" aria-describedby="basic-addon1"/>
            </div>
          </li>
          <li>
            {errors.phone &&
            <small className="small-text-red">
              <i className="fas fa-exclamation-triangle"></i> {getErrorMessage(errors.phone.type)}
            </small>}
          </li>
          <li style={{margin: 0}}><small>Full name</small></li>
          <li style={{marginTop: 5}}>
            <div className="input-group">
              <input type="text" className="form-control form-control-lg input-form-alt"
                     placeholder="Enter your full name"
                     name="name"
                     ref={register({required: true})}
                     aria-label="Username" aria-describedby="basic-addon1"/>
            </div>
          </li>
          <li>
            {errors.name &&
            <small className="small-text-red"> <i
              className="fas fa-exclamation-triangle"></i>{getErrorMessage(errors.name.type)}
            </small>}
          </li>

          <li className="text-right">
            <input type="submit" id="button" style={{display: "none"}}/>
          </li>
        </ul>
      </div>
    </form>
  );
}

const RequestReceiverForm = ({data}) => {
  const {register, handleSubmit, watch, errors} = useForm();

  const createRequest = () => {
    let requestData = models.createDeliveryOrderResponse;
    if (!helper.isEmpty(data)) {

      let merged = {...models.deliveryQuoteResponse, ...data.data};

      requestData.pick_up.address = merged.pick_up.address;
      requestData.pick_up.latitude = merged.pick_up.latitude;
      requestData.pick_up.longitude = merged.pick_up.longitude;

      requestData.pick_up.name = "";
      requestData.pick_up.phone_number = "";
      requestData.pick_up.image_url = "";

      requestData.drop_off.address = merged.drop_off.address;
      requestData.drop_off.latitude = merged.drop_off.latitude;
      requestData.drop_off.longitude = merged.drop_off.longitude;

      requestData.quote.fee = merged.fee;
      requestData.quote.currency = merged.currency;
      requestData.quote.duration = merged.duration;
      requestData.quote.duration_unit = merged.duration_unit;

      customer.createDeliveryOrder(requestData, getUserPhoneNumber()).then(response => {
        console.log(response.data);
        // setShowLoadingBar(true);
        toastifyHelper.toastify.infoToastify("Redirecting to Payment Checkout ...");
        // initializePayment(response.data);
      }).catch(error => {
        toastifyHelper.toastify.infoToastify(error.response.data.message);
      })

    } else {

    }
  }



  return (
    <form onSubmit={handleSubmit(createRequest)}>
      <div className="text-left">
        <ul className="list-unstyled">
          <li><small>Phone number</small></li>
          <li style={{marginTop: 5}}>
            <div className="input-group">
              <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                       <img style={{height: 14, marginRight: 5}} src={flag}
                                            className="img-fluid"/> +233
                                    </span>
              </div>
              <input type="text" className="form-control form-control-lg input-form"
                     placeholder="Enter your phone number"
                     name="phone"
                     maxLength="10"
                     ref={register({
                       required: true,
                       min: 9,
                       max: 10,
                       pattern: phoneNumberRegexPattern()
                     })}
                     aria-label="Username" aria-describedby="basic-addon1"/>
            </div>
          </li>
          <li>
            {errors.phone &&
            <small className="small-text-red"> <i
              className="fas fa-exclamation-triangle"></i> {getErrorMessage(errors.phone.type)}
            </small>}
          </li>
          <li style={{margin: 0}}><small>Full name</small></li>
          <li style={{marginTop: 5}}>
            <div className="input-group">
              <input type="text" className="form-control form-control-lg input-form-alt"
                     placeholder="Enter your full name"
                     name="name"
                     ref={register({required: true})}
                     aria-label="Username" aria-describedby="basic-addon1"/>
            </div>
          </li>
          <li>
            {errors.name &&
            <small className="small-text-red"> <i
              className="fas fa-exclamation-triangle"></i>{getErrorMessage(errors.name.type)}
            </small>}
          </li>
          <li style={{margin: 0}}><small>Note</small></li>
          <li className={'mt-2'}>
            <textarea style={{minHeight: 150}} className={'form-control form-control-lg input-form-alt'}></textarea>
          </li>
          <li className="text-right">
            <input type="submit" id="button" style={{display: "none"}}/>
          </li>
        </ul>
      </div>
    </form>
  );
}


export default Request;
